// A small "Gong" link per recorded call behind a meeting. The URLs are already safe: the server
// builds them with `gong.call_link`, which accepts only https links on app.gong.io.

import { gongLinkLabel } from './attendanceVerification';

export function GongLinks({ urls }: { urls?: string[] }) {
  if (!urls?.length) return null;
  return <span className="gonglinks">
    {urls.map((url, position) => <a
      key={url} className="msf" href={url} target="_blank" rel="noopener noreferrer"
      title="Open the recorded call in Gong"
    >{gongLinkLabel(position, urls.length)}</a>)}
  </span>;
}
